import gql from "graphql-tag";

export const GPS_LIVE_INTEGRATION_QUERY = gql`
  query GpsLiveIntegrationSettings {
    integrations {
      gpsLive {
        safetyEventsEnabled
      }
    }
  }
`;
